import { components } from './generated-models';

export type ApiUUID = components['schemas']['UUIDString'];
export type BankTransaction = components['schemas']['BankTransaction'];
export type CreateUserInput = components['schemas']['CreateUserInput'];
export type FileImport = components['schemas']['FileImport'];
export type FileParserType = components['schemas']['FileParserType'];
export type Graph = components['schemas']['Graph'];
export type GraphDateRange = components['schemas']['GraphDateRange'];
export type GraphKind = components['schemas']['GraphKind'];
export type GraphInput = components['schemas']['GraphInput'];
export type Group = components['schemas']['Group'];
export type GroupType = components['schemas']['GraphGroupType'];
export type HorizontalGroup = components['schemas']['HorizontalGroup'];
export type Label = components['schemas']['Label'];
export type LabelUpdate = components['schemas']['UpdateLabel'];
export type LabelCreate = components['schemas']['CreateLabel'];
export type LabelInUse = components['schemas']['LabelInUse'];
export type MoveDirection = components['schemas']['MoveDirection'];
export type MyProfile = components['schemas']['GetMyProfile'];
export type UpdateMyProfile = components['schemas']['UpdateMyProfile'];
export type OAuthAuthorizationRequest = components['schemas']['OAuthAuthorizeRequest'];
export type OAuthClient = components['schemas']['OAuthClient'];
export type OAuthClientWithSecret = components['schemas']['OAuthClientWithSecret'];
export type OAuthScope = components['schemas']['OAuthScope'];

export const OAUTH_SCOPES: readonly OAuthScope[] = ['userInfo', 'uploadFile'];
export type OperationString = components['schemas']['OperationString'];
export type OperationDouble = components['schemas']['OperationDouble'];
export type Rule = components['schemas']['Rule'];
export type RuleCondition = components['schemas']['Condition'];
export type RuleConditionInput = components['schemas']['ConditionInput'];
export type RuleInput = components['schemas']['RuleInput'];
export type SessionInfo = components['schemas']['CheckMyProfile'];
export type UpdateUserInput = components['schemas']['UpdateUserData'];
export type UserGroup = components['schemas']['UserGroup'];
export type UserProfile = components['schemas']['UserProfile'];
